var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-container",class:{fullscreen:_vm.fullscreen},style:({width:_vm.containerWidth})},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}}),_vm._v(" "),_c('div',{staticClass:"editor-custom-btn-container"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-589f4cb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/editor/index.vue
// module id = null
// module chunks = 